import React from 'react';
import { isMobile, parseNumberByPrecision } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';
import { betTypesStore } from '../../../store/betTypesStore';
import { gameColorsCodes, gameColorsOdd } from '../../../enums/gameColors';
import { rtpFormulaCalculator } from '../../../helpers/rtpFormulaCalculator';

export const GameSpecificCheckHashPopupTopSection = ({ currentData }) => {
  return (
    <div className='res-cont-circle-wrp'>
      <div className={`res-cont-circle-holder ${gameColorsCodes[currentData.roundData]}`}>
        <div className='res-cont-circle-ins'>
          <div
            className='r-circle-in'
            data={
              currentData?.roundData
                ? `x${gameColorsOdd[gameColorsCodes[currentData.roundData]]}`
                : ''
            }
          />
        </div>
      </div>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      {isMobile() && <p className='pr-f-text'>{t(globalTranslationKeys.FairnessModalTitle)}</p>}
      <p className='pr-f-text'>{t('FAIRNESS_P1')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text'>{t('FAIRNESS_P2')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P3')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P4')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P5')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P6')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P7')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P8')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P9')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P10')}</p>
      <p className='pr-f-text'>{t('FAIRNESS_P11')}</p>
      <p className='pr-f-text w-b-ba'>
        8860731B4F9523DD3A1AA686A237BB89CC5EC01448ADFFE6FFE64F12E3015C648904D3761689EA0B642B8E0A8A250ADA0773247B792541B2EE4FD89EFFA3283B
      </p>
      <p className='pr-f-text' key={Date.now()}>
        {t('FAIRNESS_P12')}
      </p>
    </>
  );
};

export const HelpPopupInnerContent = ({ t }) => {
  const { betTypes } = betTypesStore;
  const reversedBetTypeData = [...betTypes].reverse();

  return (
    <div className='result-content-b'>
      <div className='fs-help-popup-text'>
        <p>{t('GAME_RULES_P1')}</p>
        <p>{t('GAME_RULES_P2')}</p>
        <p>{t('GAME_RULES_P3')}</p>
        <p>{t('GAME_RULES_P4')}</p>
        <ul>
          <li>{t('GAME_RULES_P5')}</li>
          <li>{t('GAME_RULES_P6')}</li>
          <li>{t('GAME_RULES_P7')}</li>
          <li>{t('GAME_RULES_P8')}</li>
        </ul>
        <p>{t('GAME_RULES_P9')}</p>
      </div>
      <div className='fs-adds-table-wrapper'>
        <h3 className='fs-adds-table-title'>{t('GAME_RULES_P10')}</h3>
        <div className='fs-adds-table-wrp'>
          <table className='fs-adds-table'>
            <thead>
              <tr>
                <th colSpan='4'>color</th>
                <th colSpan='4'>odd</th>
                <th colSpan='4'>{t('RTP_EACH_MARKET')}</th>
              </tr>
            </thead>
            <tbody>
              {reversedBetTypeData.map((betType) => (
                <tr key={betType.id}>
                  <td className='fish-col' colSpan='4'>
                    <div className={`result-circle status-${betType.color}`} />
                  </td>
                  <td colSpan='4'>x{betType.odd}</td>
                  <td colSpan='4'>
                    {parseNumberByPrecision(1, rtpFormulaCalculator(betType.odd, betType.name))}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='fs-help-popup-text'>
        <p>{t('GAME_RULES_P11')}</p>
        <p>{t('GAME_RULES_P13')}</p>
        <p>{t('GAME_RULES_P12')}</p>
        <p>
          {t('CANCELATION_MESSAGE_1')}
          <br />
          {t('MALFUNCTION_MESSAGE_2')}
        </p>
      </div>
      <div className='fs-help-popup-text'>
        <p>{t('RTP')}</p>
      </div>
    </div>
  );
};
